export default "ui-layout-sidebar{display:block}\n";